module.exports = __webpack_public_path__ + "img/upperCaseN.8c6679be.svg";